import { render, staticRenderFns } from "./TabDispositivos.vue?vue&type=template&id=3694ed21&"
import script from "./TabDispositivos.vue?vue&type=script&lang=ts&"
export * from "./TabDispositivos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports